// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-list.title{ 
    display: flex;
    width: 400px;
    margin: 8px;
}
.team-list-item:not(:last-child) {
    border-bottom: 1px dotted gray;
}

.team-list-item.expanded {
    border-bottom: 0;
}

.team-list-item .team-list-actions {
    transition: width 0.4s ease, left 0.4s ease;
    position: absolute;
    width: 0;
    left: 100%;
    overflow: hidden;
    padding-left: 0;
    padding-right: 0;
    z-index: -1;
}

.team-list-item:not(.inactive-item-with-rips) .team-list-actions {
    background: rgb(36, 143, 223);
    background: linear-gradient(to right, rgb(36, 143, 223) 0%, rgb(40, 233, 234) 100%);
}

.team-list-item.inactive-item-with-rips .team-list-actions {
    background: rgba(244, 166, 97, 0.541);
    background: linear-gradient(to right, rgba(227,220,220) 0%, rgb(227,220,220) 100%);
}

.team-list-item.inactive-item .team-list-actions {
    background: rgba(75, 74, 74, 0.541);
    background: linear-gradient(to right, rgba(85, 85, 84, 0.507) 0%, rgb(184, 183, 181) 100%);
}

.team-list-item.expanded:not(.active-item) {
    opacity: 0.3;
}

.team-list-item.expanded {
    color: white;
}

.list-item.team-list-item .initials > div {
    background-color: white;
    color: #248FDF;
}

.team-list-item.expanded .team-list-actions {
    width: 100%;
    left: 0;
}

.team-list-rips > .container {
    width: inherit;
    padding: 0;
}

.team-list-close-btn {
    border: 0;
    padding: 0;
}

.team-list-item .team-list-icon {
    text-align: right;
}

.team-list-item.inactive-item.initials > div,
.team-list-item.inactive-item:not(.expanded) {
    background-color: #dad6d644;
    color: #8a8989;
}
.team-list-item.inactive-item-with-rips:not(.expanded) {
    background-color: #ecddca61;
    color: #c1a6a6;
}`, "",{"version":3,"sources":["webpack://./src/components/rip/TeamList/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;AACf;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,mFAAmF;AACvF;;AAEA;IACI,qCAAqC;IACrC,kFAAkF;AACtF;;AAEA;IACI,mCAAmC;IACnC,0FAA0F;AAC9F;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,OAAO;AACX;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,2BAA2B;IAC3B,cAAc;AAClB","sourcesContent":[".team-list.title{ \n    display: flex;\n    width: 400px;\n    margin: 8px;\n}\n.team-list-item:not(:last-child) {\n    border-bottom: 1px dotted gray;\n}\n\n.team-list-item.expanded {\n    border-bottom: 0;\n}\n\n.team-list-item .team-list-actions {\n    transition: width 0.4s ease, left 0.4s ease;\n    position: absolute;\n    width: 0;\n    left: 100%;\n    overflow: hidden;\n    padding-left: 0;\n    padding-right: 0;\n    z-index: -1;\n}\n\n.team-list-item:not(.inactive-item-with-rips) .team-list-actions {\n    background: rgb(36, 143, 223);\n    background: linear-gradient(to right, rgb(36, 143, 223) 0%, rgb(40, 233, 234) 100%);\n}\n\n.team-list-item.inactive-item-with-rips .team-list-actions {\n    background: rgba(244, 166, 97, 0.541);\n    background: linear-gradient(to right, rgba(227,220,220) 0%, rgb(227,220,220) 100%);\n}\n\n.team-list-item.inactive-item .team-list-actions {\n    background: rgba(75, 74, 74, 0.541);\n    background: linear-gradient(to right, rgba(85, 85, 84, 0.507) 0%, rgb(184, 183, 181) 100%);\n}\n\n.team-list-item.expanded:not(.active-item) {\n    opacity: 0.3;\n}\n\n.team-list-item.expanded {\n    color: white;\n}\n\n.list-item.team-list-item .initials > div {\n    background-color: white;\n    color: #248FDF;\n}\n\n.team-list-item.expanded .team-list-actions {\n    width: 100%;\n    left: 0;\n}\n\n.team-list-rips > .container {\n    width: inherit;\n    padding: 0;\n}\n\n.team-list-close-btn {\n    border: 0;\n    padding: 0;\n}\n\n.team-list-item .team-list-icon {\n    text-align: right;\n}\n\n.team-list-item.inactive-item.initials > div,\n.team-list-item.inactive-item:not(.expanded) {\n    background-color: #dad6d644;\n    color: #8a8989;\n}\n.team-list-item.inactive-item-with-rips:not(.expanded) {\n    background-color: #ecddca61;\n    color: #c1a6a6;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
